import React from 'react';
import PropTypes from 'prop-types';
import Card from './Card';
import styles from './FeedbackCard.module.scss';
import DefaultAvatar from '../../../assets/icons/svgIcons/avatar.svg';
import { parseDate } from '../../../helpers/date';
import { getOrganizationFeaturesRequest } from '../../../helpers/api';
import Avatar from '@material-ui/core/Avatar';
import Tag from '../Tag';
import { routes } from '../../../assets/routes';
import { generatePath, useHistory } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from '../../../i18n/LanguageProvider';

const FeedbackCard = (props) => {
  const { repr } = useTranslation();
  const history = useHistory();
  const { data: orgFeatures } = useQuery(
    ['organizationFeatures'],
    getOrganizationFeaturesRequest
  );

  const hasFeedbackTitle = orgFeatures?.data?.find(
    (feature) => feature.feature_name === 'feedback_title'
  )?.active;

  return (
    <Card
      {...props}
      onClick={() => {
        history.push(generatePath(routes.FEEDBACK, { id: props.data.id }));
      }}
    >
      <div className={styles.wrapper}>
        <div className={styles.body}>
          <div className={styles.info}>
            <div className={styles.pics}>
              <Avatar
                alt={
                  props.receiver
                    ? props.data.sender.first_name
                    : props.data.receiver.first_name
                }
                src={
                  props.receiver
                    ? props.data.sender.avatar?.thumbnail || DefaultAvatar
                    : props.data.receiver.avatar?.thumbnail || DefaultAvatar
                }
                className={styles.small}
              />
              <span>
                {props.receiver
                  ? `${props.data.sender.first_name} ${props.data.sender.last_name}`
                  : `${props.data.receiver.first_name} ${props.data.receiver.last_name}`}
              </span>
            </div>
          </div>
          <div className={styles.feedback}>
            {props.data.status_repr.en === 'new' && (
              <Tag
                color="secondary"
                name={repr(props.data.status_repr, 'conversationStatus')}
              />
            )}
            <div className={styles.time}>
              {parseDate(props.data.created_at)}
            </div>
          </div>
        </div>
        <div className={styles.note}>
          {hasFeedbackTitle && props.data.title && (
            <div className={styles.title} dir="auto">
              {props.data.title.length > 55
                ? props.data.title.slice(0, 55) + '...'
                : props.data.title}
            </div>
          )}
          <div className={styles.message} dir="auto">
            {props.data.message}
          </div>
        </div>
        {props.data.latest_attachment && (
          <div className={styles.attachmentIcon}>
            <span className={styles.fileIcon}>📎</span>
            <span className={styles.filename}>
              {props.data.latest_attachment.length > 40
                ? props.data.latest_attachment.slice(0, 40) + '...'
                : props.data.latest_attachment}
            </span>
          </div>
        )}
      </div>
    </Card>
  );
};

FeedbackCard.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    sender: PropTypes.shape({
      id: PropTypes.number,
      img: PropTypes.string,
      first_name: PropTypes.string,
      last_name: PropTypes.string,
      avatar: PropTypes.shape({
        thumbnail: PropTypes.string
      })
    }),
    receiver: PropTypes.shape({
      id: PropTypes.number,
      img: PropTypes.string,
      first_name: PropTypes.string,
      last_name: PropTypes.string,
      avatar: PropTypes.shape({
        thumbnail: PropTypes.string
      })
    }),
    message: PropTypes.string,
    title: PropTypes.string,
    created_at: PropTypes.string,
    status_repr: PropTypes.shape({
      en: PropTypes.string,
      fa: PropTypes.string,
      index: PropTypes.number
    }),
    latest_attachment: PropTypes.string
  }),
  receiver: PropTypes.bool
};

export default FeedbackCard;
